import { useMessageSource } from "react-message-source";
import * as Yup from "yup";
import { useYesNoValidator } from "../shared/components/validator";

export default function useValidationSchema() {
  const { getMessage } = useMessageSource();

  return Yup.object().shape({
    customerNumber: Yup.string()
      .nullable()
      .when("isCardholderLoyaltyParticipant", {
        is: "yes",
        then: () =>
          Yup.string()
            .matches(
              /^\d{4} \d{4} \d{4} \d{3}$/,
              getMessage("Validation.message-mustHaveSpecifiedFormat"),
            )
            .required(getMessage("Validation.message-required")),
      }),
    isCardholderLoyaltyParticipant: useYesNoValidator(),
  });
}
